'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'door-open';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f52b';
var svgPathData = ['M32 64C32 28.7 60.7 0 96 0L224 0c35.3 0 64 28.7 64 64l0 384-256 0 0-384zM160 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z', 'M288 64l64 0 0 416c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-384c0-35.3-28.7-64-64-64L224 0c35.3 0 64 28.7 64 64zM224 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0 0-64-256 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDoorOpen = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;